export default {
	termsAndConditions: {
		lastUpdate: 'Zadnja posodobitev: 10. junij 2024',
		content: `
		<p>Pogoji, ki jih boste našli spodaj, so pomembni, ker:</p>
		<ul>
			<li>Uveljavijo svoje zakonske pravice na {siteName}.</li>
			<li>Pojasnite pravice, ki nam jih podelite, ko uporabljate {siteName}.</li>
			<li>
				Opisujejo pravila, ki jih morajo vsi upoštevati pri uporabi {siteName}.
			</li>
		</ul>
		<p>
			Pozorno preberite te pogoje, pa tudi naše {privacyPolicyLink} in vse druge
			dokumente, navedene v teh pogojih.
		</p>
		<p>Začnimo...</p>
		<h3>1. UVOD IN PODATKI {siteNameUpper}.</h3>
		<p>
			Spletno mesto {websiteLink} (v nadaljevanju "spletno mesto") je v lasti podjetja
			{siteName} S.L (v nadaljevanju "{siteName}"), podjetje
			registrirano v skladu s špansko zakonodajo z naslovom Avenida de
			Cerdanyola, št. 75, 1º, Sant Cugat del Vallès (Barcelona), imetnik številke CIF
			B-56.768.260 in registrirano v trgovskem registru Barcelone v zvezku
			49065, list 0033, list B-606324, 1. vpis.
		</p>
		<p>
			{siteName} vam daje spletno mesto na razpolago, da lahko pridete do njega
			nas bolje poznate, poznate storitve, ki jih nudimo in če želite, se lahko obrnete
			in po potrebi skleniti pogodbo z nami.
		</p>
		<h3>2. NAMEN IN OBSEG UPORABE POGOJEV UPORABE</h3>
		<p>
			Ti pogoji uporabe skupaj z {privacyPolicyLink} in
			{cookiesPolicyLink}, pravni okvir, ki ureja uporabo spletne strani
			{websiteLink}. Ti pogoji uporabe vam bodo na voljo na spletni strani
			v angleščini, tako da si jih lahko kadar koli ogledate, arhivirate ali natisnete
			kadarkoli želiš.
		</p>
		<p>
			Za vsa vprašanja v zvezi z zdravljenjem, ki ga izvaja {siteName}.
			vaših osebnih podatkov obiščite našo {privacyPolicyLink} in našo {cookiesPolicyLink}.
			Oba pravilnika vam bosta na voljo tudi v angleščini, da boste lahko
			si jih lahko kadar koli ogledate, arhivirate ali natisnete.<br />
			{siteName} na spletnem mestu uporablja piškotke tretjih oseb. Če želite izvedeti več
			o vrsti piškotkov, ki se uporabljajo na spletu {websiteLink}, njihovem namenu in kako
			za konfiguracijo vašega brskalnika v primeru, da ne želite, da uporabljamo te piškotke,
			obiščite našo {cookiesPolicyLink}.
		</p>
		<p>
			Oba ta pogoja uporabe, kot tudi {privacyPolicyLink} in 
			{cookiesPolicyLink} so bili pripravljeni v skladu z veljavnimi določili
			veljavne predpise, med drugim zakon 34/2002 o storitvah
			Informacijska družba in elektronsko poslovanje ter Uredba (EU) 2016/679 z dne
			Evropskega parlamenta in Sveta z dne 27. aprila 2016 o
			varstvo fizičnih oseb pri obdelavi osebnih
			podatke in prost pretok teh podatkov ter s katerimi Direktivo 95/46 / CE
			se razveljavi.
		</p>
		<h3>3. DOSTOP DO SPLETNE STRANI IN SPREJETJE</h3>
		<p>
			Dostop do spletnega mesta je brezplačen, razen v delu, ki se nanaša na stroške
			povezava prek telekomunikacijskega omrežja, ki ga omogoča internet
			ponudnik dostopa, s katerim ste sklenili pogodbo. Po spletni strani lahko prosto brskate
			in do njega dostopajte tolikokrat, kot želite. Za dostop in krmarjenje po spletnem mestu,
			ni vam treba registrirati, razen če želite najeti storitev.
		</p>
		<p>
			Z uporabo spletnega mesta pridobite pogoj uporabnika spletnega mesta
			(v nadaljevanju "uporabnik") in pomeni vaše popolno in brez zadržkov sprejemanje
			te pogoje uporabe, kot tudi {privacyPolicyLink} in {cookiesPolicyLink}
			spletnega mesta. Poleg tega se strinjate, da storitve ne boste uporabljali za nezakonite namene
			namene.
		</p>
		<p>
			Z dostopom do spletnega mesta in brskanjem po njem izjavljate pod svojim
			odgovornost, da ste polnoletni in da imate potrebne pravne
			zmožnost dostopa do spletnega mesta in njegove uporabe ter izjavljate, da ste v celoti
			razumeti in sprejeti te pogoje uporabe brez zadržkov.
		</p>
		<p>
			Po drugi strani pa vas obveščamo, da iz pravnih razlogov arhiviramo
			elektronske dokumente, v katerih so formalizirani nakupi. Lahko dostopate
			te dokumente kadar koli tako, da jih zahtevate na: {supportLink}.
		</p>
		<h3>4. POGOJI UPORABE SPLETNE STRANI</h3>
		<p>
			Uporabnik se strinja z uporabo spletne strani v skladu s temi pogoji uporabe,
			veljavna zakonodaja in dobra vera. Tako se bo uporabnik odzval na {siteName}.
			 in pred katero koli tretjo osebo za škodo in izgube, ki izhajajo iz
			uporabo v nasprotju s temi pogoji, zakonodajo in dobro vero
			s strani uporabnika spletnega mesta.
		</p>
		<h3>5. OPIS STORITVE</h3>
		<p>
			Preko storitve {siteName} omogoča naročnino na storitev za
			izvajati urejanje slik.
		</p>
		<p>
			Jezik, v katerem je pogodba med {siteName} in kupcem
			bo sklenjena tista država izvora.<br />
			Postopek nakupa v spletni storitvi bo naslednji:
		</p>
		<ol>
			<li>Na spletnem mestu se morate registrirati z uporabniškim imenom in geslom.</li>
			<li>
				Ob registraciji mora uporabnik izbrati enega izmed plačilnih načrtov
				najdete v razdelku s cenami in bodo glede na
				izbrani načrt. Vsak kredit vam bo omogočil urejanje ene slike.
			</li>
			<li>
				Po nakupu storitve bo uporabnik imel administracijo
				panel, kjer bodo našli:
				<ul>
					<li>
						Razdelek s seznamom vseh obdelanih slik, ki so
						lahko urejate, kolikorkrat želite, in prenesete na svoj
						napravo.
					</li>
					<li>
						Razdelek Načrti in plačila za ogled računov in preklic
						naročnina.
					</li>
					<li>Razdelek v Mojem računu, kjer lahko spremenite nastavitve računa.</li>
				</ul>
			</li>
		</ol>
		<p>
			Ko bo nakup storitve opravljen, ga bo potrdil
			pošiljanje e-pošte v največ 24 urah na naslov, ki ga imate
			navedeno. Navedel bo storitev, kako preklicati naročnino, njeno
			znesek, veljavne davke, način plačila in veljavne pogoje ter
			pogoji.
		</p>
		<h4>5.1 Naročnina</h4>
		<p>
			Naročnina na storitev se razlikuje glede na izbrani paket in bo
			samodejno podaljša za enako časovno obdobje do njegovega prenehanja.
			Če ne prekličete naročnine, nas pooblaščate za nalaganje
			ustrezno letno naročnino na vašem plačilnem sredstvu.
		</p>
		<p>
			Svojo naročnino na storitev lahko kadar koli prekličete in to tudi storite
			še naprej imate dostop do njega do konca vašega letnega obračunskega obdobja. Za
			v zakonsko dovoljenem obsegu so plačila nepovratna in jih ne zagotavljamo
			povračila ali krediti za delna letna naročniška obdobja.
		</p>
		<h3>6. CENA IN DAVKI</h3>
		<p>
			Cene izdelkov v ponudbi na {siteName} so navedene v evrih
			(€) ali valuto države, iz katere je opravljen nakup, vrednost
			Dodatni davek (DDV), ki velja v času nakupa, se obračuna na ceno
			izdelkov.
		</p>
		<p>
			V vsakem primeru je lahko operacija oproščena ali neobdavčena z DDV, odvisno od tega
			državo vašega prebivališča ali stanje, v katerem delujete. Zaradi tega razloga,
			v nekaterih primerih se lahko končna cena naročila spremeni glede na
			ena prikazana.<br />
			Pri nakupih subjektov, ki so oproščeni plačila DDV, bo to označeno z
			pošiljanje njihove številke za DDV/NIF po e-pošti na {supportLink}, ne beleženje
			nakupe z navedenim davkom.
		</p>
		<h3>7. NAČIN PLAČILA</h3>
		<p>
			Spletno plačilo kupljene storitve je možno s kreditno ali debetno kartico.
			V tem smislu {siteName} obvešča imetnike kreditnih in debetnih kartic, da
			transakcije v spletni trgovini potekajo preko varnega plačila
			prehod, ki uporablja tehnologijo SSL za zagotavljanje varnosti prenosa podatkov.
		</p>
		<h3>8. PRAVICA DO ODSTOPA OD ODSTOPA IN VRAČILA ODNOSA</h3>
		<h4>8.1. Pravica do odstopa od pogodbe</h4>
		<p>
			Glede na vrsto izdelka, ki se trži v naši spletni storitvi, programska oprema v digitalni obliki
			formatu QR, pravica do odstopa ne bo veljala v skladu z
			člen 103, črka m) kraljevega zakonodajnega odloka 1/2007 z dne 16. novembra,
			da je spremenjeno besedilo Splošnega zakona o varstvu potrošnikov in
			Uporabniki in drugi dopolnilni zakoni so odobreni.
		</p>
		<h4>8.2. Vračila</h4>
		<p>
			Ne glede na načrt, ki ga je izbral uporabnik, zneske, ki jih plača uporabnik in do
			obsegu, ki ga dovoljuje zakon, ne bo mogoče povrniti.
		</p>
		<p>
			Pogodbene storitve ni dovoljeno dodeliti ali prenesti na druge uporabnike
			servis.
		</p>
		<p>
			V vsakem primeru lahko uporabnik koristi pogodbeno storitev do konca
			pogodbeno obdobje.
		</p>
		<h3>9. VELJAVNOST PONUDB</h3>
		<p>
			Storitve, ponujene v storitvi, in njihove cene bodo na voljo za
			nakup, medtem ko so v katalogu storitev, prikazanih prek tega
			Spletna stran.
		</p>
		<p>
			V vsakem primeru si {siteName} pridržuje pravico do sprememb
			meni, da je primerno v storitvi, da lahko posodablja izdelke in storitve
			odvisno od trga.
		</p>
		<p>
			{siteName} si pridržuje pravico do spremembe cen brez predhodnega obvestila. mi
			vas obveščamo, da kljub posodobitvam cen
			Storitev, lahko vsebujejo napake. Vse morebitne napake bomo nemudoma odpravili
			pojavijo, vendar za storitev ne bodo zavezujoči.
		</p>
		<h3>10. VARNOST</h3>
		<p>
			Kot je navedeno zgoraj, celoten postopek nakupa, kot tudi prenos
			vaših osebnih podatkov in plačilnih sistemov, se izvaja na varni strani in
			na šifriran način prek protokola SSL.
		</p>
		<p>
			Zagotavljamo varnost storitve v skladu s trenutnimi
			tehnološko znanje. Vendar {siteName} ne more zagotoviti celotnega
			prihodnjo varnost storitve. V vsakem primeru obljubljamo, da bomo popravili in
			izvesti ustrezne korektivne ukrepe za popravek morebitne varnosti
			kršitev čim prej.
		</p>
		<p>
			Strinjate se, da boste takoj obvestili {siteName} po e-pošti {supportLink}
			kakršnih koli situacij, ki bi lahko vodile do lažnega predstavljanja uporabnikove identitete.
		</p>
		<h3>11. SPREMEMBE IN NIČNOST</h3>
		<p>
			Pogoje in določila storitve bomo morda posodobili tudi v prihodnosti
			kot značilnosti in funkcije same storitve.
		</p>
		<p>
			O spremembah pogojev vas bomo obvestili z obvestilom
			na vidnem mestu na naši spletni strani in/ali po elektronski pošti.
		</p>
		<p>
			Če je navedena katera koli klavzula, vključena v teh pogojih, v celoti oz
			delno, nično ali neučinkovito, bo vplivalo le na navedeno določbo ali del
			tega, ki je ničen ali neučinkovit. Pogoji bodo veljali v
			vse ostalo, ki ima takšno določbo, ali njen del, na katerega vpliva
			ni postavljen.
		</p>
		<h3>12. ZAHTEVKI IN TOŽBE, KI IZHAJAJO IZ POGODBE</h3>
		<p>
			Kolikor je to mogoče, to storitev ureja španska zakonodaja.<br />
			Zaradi poenostavitve reševanja zahtevkov po pravdnem postopku in
			zmanjšati stroške, ne izključujemo možnosti, da se podredimo an
			Lastniško arbitražo arbitražnega sodišča pri gospodarskih zbornicah in
			Industrija. V tem smislu in v skladu z veljavnimi predpisi oz.
			 {siteName} obvešča o obstoju evropskega spletnega reševanja sporov
			platformo, ki omogoča izvensodno reševanje tovrstnih sporov za
			pogodbe, sklenjene tudi na spletu med potrošniki in internetnimi storitvami
			ponudniki. Do te platforme lahko dostopate prek naslednjega spletnega mesta:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. PRAVICE INTELEKTUALNE IN INDUSTRIJSKE LASTNINE</h3>
		<p>
			Spletna stran in njena vsebina sta predmet zaščite pri uporabi
			trenutni nacionalni predpisi o intelektualni in/ali industrijski lastnini, kot
			kot tudi pri uporabi mednarodnih konvencij, ki se uporabljajo pri tem
			zadeve. {siteName} je lastnik ali ima ustrezno licenco za vse
			Pravice intelektualne in industrijske lastnine na spletnem mestu in njegovi vsebini.
		</p>
		<p>
			Kakršna koli oblika reproduciranja, distribucije, javnega priobčitve, preoblikovanja,
			dajanje na voljo in na splošno vsako drugo dejanje izkoriščanja ali ne
			za komercialne namene spletnega mesta ali njegove vsebine, brez predhodnega
			izrecno soglasje {siteName}. Izrecno je prepovedano brisanje
			identifikacijo podatkov {siteName} kot lastnika Intelektualca in
			Pravice industrijske lastnine spletnega mesta ali njegove vsebine.
		</p>
		<p>
			{siteName} si pridržuje vse pravice intelektualne in industrijske lastnine
			nad spletnim mestom in njegovo vsebino, pri čemer si pridržuje tudi izvajanje vseh pravnih
			dejanja, ki temu ustrezajo, da bi prenehali, preprečili ali preganjali katero koli
			nedovoljena uporaba spletnega mesta ali njegove vsebine. V nobenem primeru in pod št
			okoliščinah dostopa do spletnega mesta ali njegove uporabe s strani uporabnika ali tretje osebe
			stranke predstavljajo ali nakazujejo kakršno koli dodelitev s strani {siteName}
			pravice intelektualne ali industrijske lastnine spletnega mesta ali njegove vsebine.
			V nobenem primeru pomanjkanje zahteve s strani {siteName} za prenehanje uporabe
			Spletno mesto ali njegova vsebina je lahko nezakonita ali v nasprotju s temi pogoji
			razumeti kot tiho soglasje s strani {siteName} za takšne uporabe ali kot odpoved
			izvajanju katerega koli pravnega dejanja, ki bi lahko ustrezalo temu.
		</p>
		<h3>14. ODGOVORNOSTI IN GARANCIJE</h3>
		<p>
			Uporabnik mora uporabljati spletno mesto in njegove vsebine v skladu z
			določil teh pogojev uporabe, veljavne zakonodaje in dobre vere. Kaj
			uporaba spletnega mesta ali njegovih vsebin v nasprotju s temi splošnimi pogoji,
			zakon ali dobra vera je izrecno prepovedana, ne glede na to, ali je navedena uporaba
			gospodarski namen ali ne.<br />
			Uporabnik bo odgovoren za kakršno koli škodo ali škodo, povzročeno {siteName}
			 ali tretjim osebam, ki izhajajo neposredno ali posredno iz kakršne koli uporabe
			ki jih uporabnik naredi s spletno stranjo ali njeno vsebino v nasprotju s temi
			pogojev, zakona, morale, javnega reda ali dobre vere.
		</p>
		<p>
			Da bi bila spletna stran in njena vsebina dostopna uporabniku, {siteName}
			 zahteva storitve tretjih oseb. Možno je, da
			kljub prizadevanjem {siteName}, da ohrani spletno mesto na voljo
			in dostopen uporabnikom, se lahko njegova razpoložljivost začasno prekine, prekine oz
			odpovedano zaradi razlogov, ki niso {siteName}. Zato {siteName}
			ne zagotavlja odsotnosti prekinitev ali napak pri dostopu do
			Spletno mesto ali njegova vsebina, niti da so posodobljeni ali vedno prikazani v
			njihova najnovejša različica. Posledično {siteName} zavrača vse
			odgovornost za škodo, ki bi lahko nastala uporabniku ali tretjim osebam kot
			posledica prekinitve, prekinitve, pomanjkanja kontinuitete, izpada omrežja
			ali prekinitev povezave s spletno stranjo.
		</p>
		<p>
			V nobenem primeru in pod nobenimi pogoji {siteName} ne bo odgovoren za
			škoda ali izguba, povzročena uporabniku zaradi vzrokov, ki jih ni mogoče pripisati {siteName}
			 kot na primer in v nobenem primeru omejujočega, naravnega
			nesreče, razmere višje sile ali skrajne nuje, virusi, škodljivi
			komponente, okvare brskalnika, padci omrežja, vdori v računalnik oz
			napadi tretjih oseb.
		</p>
		<h3>15. POVEZAVE</h3>
		<p>
			Spletna mesta, platforme, forumi, klepeti, blogi ali zunanja družbena omrežja, ki
			povezava ali povezava do spletnega mesta morajo jasno sporočati, da nimajo
			avtorizacijo ali nadzor nad {siteName} in to omenjeno povezovanje oz
			povezava ne vključuje, domneva ali implicira kakršne koli povezave med {siteName}
			 in spletnih mest, platform, forumov, klepetov, blogov ali zunanjih
			socialna omrežja, ki povezujejo ali povezujejo s spletno stranjo.
		</p>
		<p>
			V vsakem primeru mora biti katera koli povezava, ki je namenjena spletni strani, usmerjena
			neposredno na domačo stran ali domačo stran spletnega mesta s klikom na URL
			spletnega mesta, ki pokriva celoten zaslon domače strani ali začetne strani
			spletnega mesta, tako da je povezava absolutna in popolna brez uporabe
			okvirji, okvirji ali hiperpovezave. {siteName} se v nobenem primeru ne odzove
			in v nobenem primeru na vsebino, informacije ali podatke, povezane z
			spletne strani, njene vsebine ali katere koli druge zadeve, ki jo vsebujejo spletne strani, platforme,
			forumi, klepeti, blogi ali socialna omrežja tretjih oseb, ki povezujejo ali povezujejo na
			Spletna stran.
		</p>
		<p>
			Izrecno je prepovedano povezovanje ali povezovanje na spletno mesto s spletnih mest,
			platforme, forumi, klepeti, blogi ali socialna omrežja v nasprotju z zakonom, moralo
			in dobrih običajev, predvsem tistih s pornografskimi, nedovoljenimi, nezakonitimi oz
			vsebine, ki kršijo človekove pravice.
		</p>
		<p>
			Po drugi strani pa lahko spletno mesto vsebuje povezave do spletnih mest tretjih oseb,
			platforme, forumi, klepeti, blogi ali družbena omrežja. {siteName} ne
			imeti človeška in/ali tehnična sredstva za poznavanje ali nadzor informacij in
			vsebino, ki se pojavlja na spletnih mestih tretjih oseb. Zato v nobenem primeru {siteName}
			 odgovarja za vsebino povezanih spletnih mest in pod št
			okoliščinah se lahko omenjene povezave štejejo za učinkovito poznavanje vsebine
			spletnih mest, do katerih se povezujejo.
		</p>
		<h3>16. VARSTVO PODATKOV</h3>
		<p>
			Kot je navedeno v {privacyPolicyLink}, se {siteName} zavezuje, da bo uporabljal uporabnika
			podatkov, spoštovati njihovo zaupnost in jih uporabljati v skladu z
			namen zdravljenja, kot tudi izpolniti svojo obveznost shranjevanja.
			in prilagodite vse ukrepe, da preprečite spreminjanje, izgubo, obdelavo ali nepooblaščeno
			dostop v skladu z določili veljavne zakonodaje glede
			varstvo osebnih podatkov.
		</p>
		<p>
			Spletna stran vključuje ustrezne zaščitne ukrepe in uporablja industrijski standard
			tehnologijo za izboljšanje varnosti, celovitosti, popolnosti, točnosti in
			varovanje osebnih podatkov, ki jih je zbrala in vzpostavila
			razumne previdnostne ukrepe za zaščito teh informacij pred morebitno izgubo oz
			zloraba. Njegova pravila o varstvu podatkov in varnosti se redno pregledujejo
			in po potrebi izboljšana ter si prizadeva zagotoviti, da le pooblaščeni
			osebe lahko dostopajo do podatkov, ki jih posreduje uporabnik.
		</p>
		<p>
			Če želite izvedeti več o upravljanju in zdravljenju, ki ga izvaja {siteName}
			 vaših podatkov, preberite našo {privacyPolicyLink} in našo {cookiesPolicyLink}.
		</p>
		<h3>17. TRAJANJE IN SPREMEMBA</h3>
		<p>
			Ti pogoji uporabe bodo veljali, dokler bodo izpostavljeni
			uporabniki, tako da takoj, ko so v celoti ali delno spremenjeni ali posodobljeni,
			ti pogoji prenehajo veljati kot novi pogoji uporabe
			tiste, ki urejajo uporabo spletnega mesta.
		</p>
		<p>
			{siteName} si pridržuje pravico, da jih pregleda, spremeni ali posodobi
			pogoje uporabe kadarkoli. V primeru kakršnekoli spremembe teh pogojev
			uporabe iz katerega koli razloga, bo {siteName} obvestil uporabnike na domači strani
			spletu o navedeni okoliščini, da so ustrezno obveščeni in se lahko posvetujejo
			revizije, modifikacije ali posodobitve sedanjih pogojev uporabe za
			vaše zadovoljstvo.
		</p>
		<h3>18. SPLOŠNO</h3>
		<p>
			V nobenem primeru in pod nobenim pogojem ne sme neuresničevanje vaših pravic
			s strani {siteName} razumeti kot opustitev le-teh.
		</p>
		<p>
			Naslovi v teh pogojih so zgolj okvirni oz
			informativni, tako da ne vplivajo na interpretacijo, jo kvalificirajo ali razširjajo
			od tega.
		</p>
		<p>
			V primeru, da je bila katera od klavzul iz teh pogojev
			razglašen za ničnega, zlorabnega ali neizvršljivega, v celoti ali delno, s strani sodišča
			ali upravni organ, bo navedena izjava posamično vplivala na klavzulo
			v vprašanju, jemanje kot ne in brez razglasitve ničnosti, zlorabe oz
			neuporabnost, ki se v nobenem primeru razširi na preostanek
			pogojev, ki bodo obstajali.
		</p>
		<p>
			Ti pogoji uporabe, kot tudi {privacyPolicyLink} in {cookiesPolicyLink}
			ves čas urejajo veljavni španski predpisi.
		</p>
		<h3>19. STORITEV ZA STRANKE</h3>
		<p>
			Za kakršna koli pojasnila, incident ali zahtevek nas lahko kontaktirate preko:<br />
			E-pošta: {supportLink}<br />
			Poštni naslov: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španija.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Zadnja posodobitev: 10. junij 2024',
		content: `
			<h3>1. Odgovorna oseba in opis</h3>
			<h5>1.1. Odgovoren</h5>
			<p>Oseba, odgovorna za obdelavo tega mesta, je Remove Background S.L (v nadaljevanju Odstrani ozadje 
			ali storitev), z naslovom Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španija.</p>
			<p>NIF: B56768260<br> E-pošta: {supportLink}</p>

			<h5>1.2. Opis</h5>
			<p>Sprejemanje pravilnika o zasebnosti Odstrani ozadje (v nadaljevanju "Politika zasebnosti") je nujen pogoj 
				za uporabo naše spletne strani in zagotavljanje storitve (v nadaljevanju »storitev«).<br>
				Ta pravilnik o zasebnosti ureja zbiranje, obdelavo in uporabo vaših osebnih in neosebnih podatkov 
				kot uporabnik Odstrani ozadje, od datuma začetka veljavnosti, ki je prikazan v glavi.<br>
				Za obdelavo vaših osebnih podatkov je Remove Background v skladu z veljavno lokalno in evropsko zakonodajo, 
				kot tudi njegove izvedbene predpise.</p>


			<h3>2. Zbrane informacije</h3>
			<p>Dostop do naše spletne strani je mogoč brez potrebe po posredovanju kakršnih koli informacij, čeprav se morate registrirati in / 
				ali sklenete naše načrte, nam boste morali posredovati nekaj osebnih podatkov. Podatki (osebni 
				ali neosebne), ki jih zbira storitev, se lahko glede na to razlikujejo.<br>
				Osebni in neosebni podatki, ki jih zbira storitev, bodo do nas prišli na tri načine: 1) tisti, ki 
				se samodejno zbira 2) tisto, ki nam jo posredujete prostovoljno, in 3) tisto, ki jo zagotovijo tretje osebe.</p>

			<h5>2.1. Tisti, ki se zbere samodejno</h5>
			<p>Te informacije bodo sestavljene iz:</p>
			<ul>
				<li>Tisti, zbran prek piškotkov ali podobnih mehanizmov, shranjenih v vaši napravi, vedno z vašim soglasjem ali v 
					skladno z drugimi pravnimi podlagami. Za več informacij preverite naš pravilnik o piškotkih.</li>
				<li>IP, s katerega je vzpostavljena povezava, vrsta uporabljene naprave in njene značilnosti, različica 
					operacijski sistem, vrsta brskalnika, jezik, datum, država, čas zahteve, 
					med drugim URL naslova, iz katerega prihajate, URL, na katerega greste, ali uporabljeno mobilno omrežje.</li>
				<li>Podatki o uporabi storitve in morebitne napake, odkrite med njeno uporabo.</li>
				<li>Poleg tega Odstrani ozadje uporablja Google Analytics, analitično storitev, ki jo zagotavlja Google, LLC. 
					s sedežem v Združenih državah Amerike s sedežem na naslovu 1600 Amphitheatre Parkway, Mountain View, California 94043. 
					Za zagotavljanje teh storitev uporablja piškotke, ki zbirajo podatke, vključno z IP naslovom uporabnika, 
					ki jih bo Google posredoval, obdelal in shranil v skladu s pogoji, določenimi na spletu www.google.com. 
					Vključno z morebitnim posredovanjem omenjenih informacij tretjim osebam zaradi zakonske zahteve oz 
					ko omenjene tretje osebe obdelujejo podatke v imenu Googla.</li>
			</ul>
			<p>V vsakem primeru lahko onemogočite piškotke Google Analytics <a href="{externalLink: disableGoogleAnalyticsLink}">tukaj</a>.</p>

			<h5>2.2. Tisti, ki ga zagotovite prostovoljno</h5>
			<p>Te informacije bodo sestavljene iz:</p>
			<ul>
				<li>Vsi podatki so obvezni.</li>
				<li>Tisti, ki ga Odstrani ozadje zahteva za dokončanje vaše registracije v spletu: med drugim ime in priimek, naslov in e-pošta.</li>
				<li>Vsi podatki so obvezni.</li>
				<li>Podatki, osebni ali ne, za dokončanje pogodbe o storitvi, kot sta vaš e-poštni naslov in številka kreditne ali debetne kartice.</li>
				<li>Informacije, osebne ali ne, ki jih lahko vsebujejo sporočila, poslana prek kontaktnih ali mnenjskih kanalov, vzpostavljenih v storitvi, 
					na primer vaše ime in e-poštni naslov.</li>
			</ul>

			<h5>2.3. Tisti, ki ga zagotovijo tretje osebe</h5>
			<p>Te informacije bodo sestavljene iz:</p>
			<ul>
				<li>Tisti, ki ga zagotavljajo plačilni sistemi ali procesorji kreditnih kartic, na primer čas nakupa ali njegov znesek.</li>
			</ul>


			<h3>3. Pravice in nameni</h3>
			<p>Obveščamo vas, da je izpolnjevanje obrazcev prostovoljno. Če pa ne izpolnite zahtevanih polj 
				(običajno označeno z zvezdico), uporaba nekaterih funkcij storitve ne bo mogoča ali bo omejena.<br>
				Osebni podatki, ki nam jih posredujete, bodo vključeni in obdelani v Registru dejavnosti zdravljenja Odstrani ozadje 
				da bi lahko ugodili vašim zahtevam, zagotovili zahtevano storitev in vas obveščali o zadevah v zvezi z dejavnostjo 
				podjetja in njegovih storitev.<br>
				Kadar koli lahko uveljavljate pravice do dostopa, popravka, izbrisa, omejitve vašega zdravljenja, 
				nasprotovanju in prenosljivosti vaših osebnih podatkov po e-pošti, naslovljeni na: {supportLink} ali poštni naslov: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španija.<br>
				V obeh primerih se morate identificirati z imenom in priimkom ter po potrebi kopijo DNI ali osebne izkaznice.<br>
				V primeru, da ste dali soglasje za določen namen, imate pravico, da soglasje kadarkoli prekličete, 
				ne da bi to vplivalo na zakonitost zdravljenja na podlagi privolitve pred njenim preklicem.<br>
				Poleg tega, če menite, da obstaja težava z načinom, na katerega Remove Background obravnava vaše podatke, 
				svoje pritožbe lahko naslovite na ustrezni <a href="{knowYourRightsLink}">organ za varstvo podatkov</a>, ki je <a href="{aepdLink}">španska agencija za varstvo podatkov</a> 
				tisti, ki je naveden v primeru Španije.</p>


			<h3>4. Starost</h3>
			<p>V zvezi z uporabo spletne storitve izjavljate, da ste polnoletni in da imate potrebno pravno 
				sposobnost, da vas zavezuje ta pogodba in uporabljate spletno mesto v skladu z njegovimi pogoji, ki jih v celoti 
				razumeti in priznati.<br>
				Izjavljate, da so vsi podatki, ki jih posredujete za dostop do storitve pred in med njeno uporabo, resnični in popolni 
				in natančno.</p>


			<h3>5. Uporaba podatkov</h3>
			<p>Odstrani ozadje bo zbrane podatke uporabil za:</p>
			<ul>
				<li>Upravljanje in posodabljanje storitve (pravna podlaga je naš zakoniti interes za vzdrževanje in ohranjanje storitve 
					posodobljen in v dobrem stanju).</li>
				<li>Razpravite vprašanja, ki jih postavljate (pravna podlaga je naš zakoniti interes za obravnavo zahtev in 
					dvomi naših uporabnikov).</li>
				<li>Obdelajte plačila, ki jih opravite (pogodba je pravna podlaga).</li>
				<li>Zagotovite pogodbeno storitev (pogodba je pravna podlaga).</li>
				<li>Vzdrževanje varnosti storitve, preiskovanje nezakonitih dejavnosti, uveljavljanje naših pogojev in določil ter
					pomoč državnim varnostnim silam v okviru njihovih morebitnih preiskav (pravna podlaga je naša 
					zakoniti interes za zagotavljanje in ohranjanje varnosti storitve in njenih uporabnikov).</li>
			</ul>
			<p>Odstrani ozadje ne uporablja samodejnih odločitev, lahko pa ustvari osnovne uporabniške profile, 
				pravna podlaga je naš zakoniti interes za komercialne namene in zagotavljanje prilagojenih ponudb.<br>
				Prav tako lahko Odstrani ozadje uporabi uporabniške podatke v obliki združenih in anonimnih podatkov, da jih prikaže tretjim osebam. 
				Statistične in demografske podatke o uporabnikih in njihovi uporabi storitve lahko delite tudi s tretjimi osebami. 
				Vendar nič od tega tem tretjim osebam ne bo omogočilo, da vas osebno identificirajo.</p>

			<h5>5.1. V e-pošti in kontaktnih obrazcih</h5>
			<p>Spletna stran ima šifriranje SSL, ki uporabniku omogoča varno pošiljanje osebnih podatkov prek standardnih kontaktnih obrazcev.<br>
				Zbrani osebni podatki bodo predmet avtomatizirane obdelave in vključeni v ustrezne datoteke 
				zapisa dejavnosti obdelave in katerega lastnik je Remove Background.</p>
			<p>V tem smislu:</p>
			<ul>
				<li>Prejeli bomo vaš naslov IP, ki bo uporabljen za preverjanje izvora sporočila, da vam lahko ponudimo ustrezno 
					priporočila (na primer predstavite informacije v pravem jeziku) in za odkrivanje morebitnih nepravilnosti 
					(na primer morebitni poskusi kibernetskega napada na storitev), kot tudi podatki, povezani z vašim ponudnikom internetnih storitev.</li>
				<li>Prav tako nam lahko svoje podatke posredujete po telefonu, e-pošti in drugih navedenih komunikacijskih sredstvih.</li>
			</ul>
			<p>Glede uporabljenega plačilnega sredstva:</p>
			<ul>
				<li>Naši ponudniki plačilnih storitev za plačilo zagotavljanja naših storitev uporabljajo kreditno ali debetno kartico. 
					Storitev ali njeno osebje v nobenem trenutku ne bo imelo dostopa do bančnih podatkov (na primer številke kreditne kartice) 
					ki jih bo uporabnik kot kupec posredoval tem tretjim osebam.</li>
			</ul>


			<h3>6. Hramba podatkov</h3>
			<p>Spodaj je navedeno, kako dolgo se hranijo podatki, ki jih obdeluje storitev:</p>
			<ul>
				<li>Razčlenjeni podatki se bodo hranili brez obdobja izbrisa.</li>
				<li>
					Podatki o strankah se bodo hranili toliko časa, kot je potrebno, in se lahko hranijo do:
					<ul>
						<li>5 let, v skladu s čl. 1964 Civilnega zakonika (osebne tožbe brez posebnega roka).</li>
						<li>6 let, v skladu s čl. 30 Gospodarskega zakonika (npr. računovodske knjige ali računi).</li>
					</ul>
				</li>
				<li>Uporabniški podatki se bodo hranili največ 12 mesecev, da lahko ugodimo njihovim zahtevam.</li>
			</ul>


			<h3>7. Podatki, deljeni s tretjimi osebami</h3>
			<p>Obstajajo tretje osebe, ki upravljajo del storitve.<br>
				Odstrani ozadje od njih zahteva, da ravnajo v skladu s tem pravilnikom o zasebnosti, kot je ustrezno, poleg tega, da imajo svojega. Vendar Odstrani ozadje ne bo odgovoren za skladnost z navedenim pravilnikom.<br>
				V nekaterih okoliščinah lahko Remove Background deli, uporablja ali hrani katere koli zbrane osebne podatke s tretjimi osebami:</p>
			<ul>
				<li>Za zagotavljanje storitve:</li>
			</ul>
			<p>Ponudniki storitev, ki izvajajo funkcije v našem imenu, kot so plačilne storitve, spletno gostovanje, poslovna analitika, storitve za stranke ali spletno trženje. Ti ponudniki storitev lahko zbirajo in imajo dostop do informacij, ki jih potrebujejo za opravljanje svojih funkcij, vendar jim ni dovoljeno deliti ali uporabljati informacij za noben drug namen.</p>
			<ul>
				<li>Za sodelovanje s pristojnimi organi:</li>
			</ul>
			<p>Če menimo, da je razumno potrebno za izpolnitev katerega koli zakona, pravnega postopka ali zakonitega interesa. V vsakem primeru bomo posredovali le nujno potrebne podatke.</p>


			<h3>8. Varnostni ukrepi</h3>
			<p>Odstrani ozadje sprejme vse tehnične in organizacijske ukrepe, potrebne za
				zaščititi varnost in celovitost zbranih osebnih in neosebnih podatkov. 
				Tako pred nepooblaščenim dostopom kot pred nenamernim spreminjanjem, izgubo ali uničenjem.<br>
				V nobenem primeru Remove Background ne more zagotoviti absolutne varnosti zbranih podatkov, 
				zato morate sodelovati in vedno uporabljati zdravo pamet glede informacij, ki jih delite.<br>
				Razumete in potrjujete, da lahko tudi po izbrisu osebni in neosebni podatki 
				ostane viden v predpomnilniku ali če so ga drugi uporabniki kopirali ali shranili.</p>


			<h3>9. Spremembe pravilnika o zasebnosti</h3>
			<p>Ta pravilnik o zasebnosti bomo morda posodobili v prihodnosti. O njegovih spremembah vas bomo obvestili z obvestilom na navedeni elektronski naslov in/ali z umestitvijo obvestila na vidno mesto na naši spletni strani.</p>


			<h3>10. Kontakt</h3>
			<p>Če imate vprašanja o tem pravilniku o zasebnosti, nas kontaktirajte na:</p>
			<p>E-pošta: {supportLink}<br> 
				Naslov: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španija.</p>`
	},
	gdpr: {
		lastUpdate: 'Zadnja posodobitev: 10. junij 2024',
		content: `
			<h3>1. Kdo je odgovoren in kako stopiti v stik z njim?</h3>
			<p>Upravljavec tega mesta je Remove Background S.L z naslovom Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španija.</p>
			<p>Nanj se lahko obrnete po e-pošti na {supportLink}.</p>

			<h3>2. Kateri podatki se zbirajo?</h3>
			<p>
				Samodejno zbiramo podatke prek piškotkov, ki jih naložimo v vašo napravo, vključno z analitiko. 
				Zbiramo tudi IP, s katerega je vzpostavljena povezava, vrsto uporabljene naprave in njene značilnosti, 
				različico operacijskega sistema, vrsto brskalnika, jezik, datum, državo, čas zahteve, 
				med drugim URL, s katerega prihajate, URL, na katerega greste, ali uporabljeno mobilno omrežje.<br>
				Uporabnik nam prostovoljno posreduje nekatere podatke, kot so ime in priimek, elektronski naslov ali bančni podatki 
				da nas lahko kontaktirate, se prijavite za storitev ali kupite naročnino.
			</p>

			<h3>3. Za kaj se uporabljajo zbrani podatki?</h3>
			<p>
				Storitev bo zbrane podatke med drugim uporabljala za upravljanje in posodabljanje storitve, odgovarjanje na vaše zahteve, 
				pošiljanje naših novic in promocijskih ponudb po e-pošti, upravljanje vaše registracije na platformi, upravljanje in zagotavljanje 
				storitve, povezane z vašo naročnino, obdelavo vaših plačil in izdajo ustreznih računov, 
				vzdrževati varnost storitve, preiskovati nedovoljene dejavnosti, uveljavljati naše pogoje in določila ter 
				pomoč državnim varnostnim silam in organom v okviru njihovih morebitnih preiskav.
			</p>

			<h3>4. Kako dolgo se hranijo?</h3>
			<ul>
				<li>Razčlenjeni podatki se bodo hranili brez obdobja izbrisa.</li>
				<li>
					Podatki o strankah se bodo hranili toliko časa, kot je potrebno, in se lahko hranijo do:
					<ul>
						<li>5 let, v skladu s čl. 1964 Civilnega zakonika (osebne tožbe brez posebnega roka).</li>
						<li>6 let, v skladu s čl. 30 Gospodarskega zakonika (npr. računovodske knjige ali račun).</li>
					</ul>
				</li>
				<li>Uporabniški podatki se bodo hranili največ 12 mesecev, da bi lahko izpolnili njihove zahteve.</li>
				<li>Uporabniški podatki, ki jih storitev naloži na strani in profile v družabnih omrežjih, se hranijo od trenutka, ko uporabnik poda svoje soglasje, do trenutka, ko ga prekliče.</li>
			</ul>

			<h3>5. Kakšne pravice imate kot uporabnik?</h3>

			<p>
				Pravica do dostopa: Prizadeta stranka ima pravico pridobiti potrditev od upravljavca podatkov o tem, ali 
				ali se ne obdelujejo osebni podatki v zvezi z njim.
			</p>
			<p>
				Pravica do popravka: prizadeta stranka ima pravico, da brez nepotrebnega odlašanja pridobi od upravljavca podatkov 
				popravek osebnih podatkov, ki so netočni in ga neposredno zadevajo. Prav tako bo zainteresirana stran 
				imajo pravico do dopolnitve nepopolnih osebnih podatkov, tudi z dodatno izjavo.
			</p>
			<p>
				Pravica do izbrisa: pravica prizadete stranke je, da od upravljavca podatkov brez nepotrebnega odlašanja doseže izbris 
				osebnih podatkov, ki ga zadevajo.
			</p>
			<p>
				Pravica do omejitve obdelave podatkov: sestoji iz pridobitve omejitve obdelave vaših podatkov s strani odgovorne osebe, 
				čeprav ima njegovo izvajanje dva vidika: 1) Ko izpodbijate točnost svojih osebnih podatkov v obdobju, ki omogoča 
				odgovorna oseba, da to preveri in 2) Ko ste ugovarjali obdelavi vaših osebnih podatkov, da odgovorna oseba 
				opravlja na podlagi zakonitega interesa ali poslanstva javnega interesa, odgovorna oseba pa preveri, ali so ti razlogi 
				prevlada nad tvojim.
			</p>
			<p>
				Pravica do prenosljivosti podatkov: pravica prizadete stranke je, da prejme osebne podatke, ki jo zadevajo, 
				ki jih je posredoval upravljavcu podatkov v strukturirani obliki za splošno uporabo in mehansko branje ter 
				jih posredovati drugemu upravljavcu, ne da bi jim to preprečil upravljavec, ki so mu bili posredovani.
			</p>
			<p>
				V tem smislu bo imela zainteresirana stranka pravico do prenosa osebnih podatkov neposredno od upravljavca 
				upravljavcu, ko je to tehnično mogoče.
			</p>

			<h3>6. Kako lahko uveljavljate svoje pravice?</h3>

			<p>
				Svoje pravice do osebnih podatkov lahko kadar koli uveljavljate tako, da pošljete e-pošto na: {supportLink} ali poštni naslov: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španija. V obeh primerih se morate identificirati z imenom in priimkom, 
				kot tudi kopijo vašega DNI ali nacionalne osebne izkaznice, če je potrebno.<br>
				Poleg tega, če menite, da obstaja težava z načinom, kako Remove Background obravnava vaše podatke, lahko svoje zahtevke usmerite 
				ustreznemu <a href="{knowYourRightsLink}">organu za varstvo podatkov</a>, ki je <a href="{aepdLink}">španska agencija za varstvo podatkov</a> 
				tisti, ki je naveden v primeru Španije.
			</p>

			<h3>7. Ali so sprejeti varnostni ukrepi?</h3>
			<p>
				Storitev izvaja vse potrebne tehnične in organizacijske ukrepe za zaščito varnosti in integritete oseb 
				in zbrani neosebni podatki. Pred nepooblaščenim dostopom in nenamernim spreminjanjem, izgubo ali uničenjem.<br>
				V nobenem primeru storitev ne more zagotoviti popolne varnosti zbranih informacij, zato morate sodelovati in 
				vedno uporabljajte zdrav razum glede skupnih informacij.<br>
				Razumete in potrjujete, da lahko tudi po izbrisu osebni in neosebni podatki ostanejo vidni v predpomnilniku ali 
				če jih kopirajo ali shranijo drugi uporabniki.
			</p>

			<h3>8. Ali obstajajo prenosi osebnih podatkov ali mednarodni prenosi?</h3>

			<p>
				Ne prenašamo podatkov ali mednarodnih prenosov. Vendar obstajajo tretje osebe, ki upravljajo del storitve 
				da zahtevamo, da ravnamo v skladu z našo politiko zasebnosti, kolikor velja zanje, in da imajo svojo. 
				Te tretje osebe so ponudniki storitev, ki izvajajo funkcije v našem imenu, kot so spletno gostovanje, 
				spremljanje analitike ali spletni razvoj.<br>
				Prav tako, če menimo, da je to razumno potrebno za izpolnitev katerega koli zakona, pravnega postopka ali zakonitega interesa. 
				V vsakem primeru vam bomo posredovali le nujno potrebne podatke.
			</p>

		`
	},
	cookiesPolicy: {
		lastUpdate: 'Zadnja posodobitev: 21. junij 2024',
		content: `
			<h3>Povzetek</h3>
			<ul>
			    <li>Uporabljeni piškotki: <strong>lastni in tretji</strong></li>
			    <li>Ali se uporabljajo za pridobivanje statističnih podatkov? <strong>Da, na podlagi našega zakonitega interesa za boljše upravljanje storitve.</strong></li>
			    <li>Storitve tretjih oseb, ki nameščajo piškotke prek tega spletnega mesta: <strong>Google, Google Analytics, Cloudflare in Stripe.</strong></li>
			</ul>

			<h3>Kako konfigurirati in onemogočiti piškotke</h3>
			<p>
			    Piškotke, nameščene na vaši napravi, lahko dovolite, blokirate ali izbrišete v spletnem brskalniku. Če ne dovolite namestitve piškotkov na vašo napravo, 
			    izkušnja brskanja se lahko poslabša. Spodaj lahko najdete, kako konfigurirati piškotke v posameznem brskalniku:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Vrste in uporaba</h3>
			<p>Storitev uporablja lastne piškotke in piškotke tretjih oseb za izboljšanje brskanja, zagotavljanje storitve in pridobivanje statističnih podatkov o uporabi spletne strani.</p>

			<h3>2. Kaj je piškotek in za kaj se uporablja?</h3>
			<p>
			    Piškotek je besedilna datoteka, ki je poslana v vaš računalnik, mobilni ali tablični spletni brskalnik in se uporablja za shranjevanje in pridobivanje informacij o
			    brskanje opravljeno. Na primer, da si zapomnite uporabniško ime in geslo ali nastavitve profila.
			</p>

			<h3>3. Katere vrste piškotkov obstajajo?</h3>
			<p>Glede na to, kdo jih upravlja:</p>
			<ul>
			    <li>Lastni piškotki; so poslani v vaš brskalnik iz naše lastne opreme ali spletnih domen.</li>
			    <li>Piškotki tretjih oseb; v vaš brskalnik so poslani iz opreme ali spletnih domen, ki jih neposredno ne upravljamo mi, temveč tretja oseba, kot je Google.</li>
			</ul>
			<p>Glede na to, kako dolgo ostanejo aktivni, obstajajo:</p>
			<ul>
			    <li>Sejni piškotki; ostanejo v datoteki piškotkov vašega brskalnika, dokler ne zapustite spletnega mesta, tako da noben ne ostane v vaši napravi.</li>
			    <li>Trajni piškotki; ostanejo v vaši napravi in naše spletno mesto jih prebere ob vsakem vašem novem obisku. Ti piškotki prenehajo delovati po določenem datumu.</li>
			</ul>
			<p>Končno, glede na njihov namen imamo:</p>
			<ul>
			    <li>Tehnični piškotki; izboljšajo brskanje in pravilno delovanje spletne strani.</li>
			    <li>Piškotki za prilagajanje; omogočajo dostop do storitve z vnaprej določenimi lastnostmi na podlagi niza kriterijev.</li>
			    <li>Analitični piškotki; omogočajo merjenje in statistično analizo uporabe ponujene storitve.</li>
			</ul>
			<p>Seznam piškotkov tretjih oseb, ki jih uporablja <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: Njihovi piškotki (NID ali CONSENT) omogočajo prilagajanje prikaza oglasov zunaj Googla ali shranjevanje informacij
			        kot je želeni jezik pri prikazovanju rezultatov iskanja.<br><a href="{externalLink: googleCookieTypes}">Več informacij</a> o vrstah piškotkov, ki jih Google uporablja v svojih različnih storitvah.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: Njihovi piškotki (kot je _ga) omogočajo štetje, kolikokrat uporabnik obišče spletno mesto, kako, kdaj in od kod.<br>
			        V vsakem primeru lahko onemogočite piškotke Google Analytics <a href="{externalLink: disableGoogleAnalytics}">tukaj</a>.
			    </li>
			    <li>Cloudflare: Če želite izvedeti več o pravilniku in uporabi piškotkov Cloudflare, kliknite <a href="{externalLink: cloudflareCookiesPolicy}">to povezavo</a>.</li>
			    <li>Stripe: Poiščite informacije <a href="{externalLink: stripeCookiesPolicy}">tukaj</a> o pravilniku in uporabi piškotkov Stripe.</li>
			</ul>
		`
	}
};
